import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SurveyView from './surveyView';
import { useSelector, useDispatch } from 'react-redux';
import Spinner from '../common/spinner';
import { getSurveyEnrichment, getSurvey } from '../modules/surveydata';

export default function SurveyViewContainer(props) {
    const id = props.match.params.surveyId;
    const dispatch = useDispatch();
    const [survey, setSurvey] = useState(null);
    const [surveyEnrichment, setSurveyEnrichment] = useState(null);
    const surveyFromStore = useSelector((state) =>
        state.surveydata && state.surveydata.surveys ? state.surveydata.surveys[id] : null
    );

    useEffect(() => {
        async function ensureSurveyLoaded() {
            // if survey removed from store → reset local state
            if (!surveyFromStore && survey) {
                setSurvey(null);
            }

            if (surveyFromStore) {
                setSurvey(surveyFromStore);
                return;
            }

            // If survey not in store, fetch it
            if (!surveyFromStore && !survey) {
                const resp = await getSurvey(id)(dispatch);
                setSurvey(resp);
            }
        }

        ensureSurveyLoaded();
    }, [id, surveyFromStore, survey, dispatch]);

    useEffect(() => {
        async function getSurveyEnrichmentData() {
            var resp = await getSurveyEnrichment(id)(dispatch);
            setSurveyEnrichment(resp);
        }
        getSurveyEnrichmentData();
    }, [id, dispatch]);

    if (!survey || !surveyEnrichment) {
        return <Spinner />;
    }
    //TODO: surveyenrichment haetaan jo surveyView moduulissa. Voidaan optimoida.
    return <SurveyView survey={survey} surveyEnrichment={surveyEnrichment} history={props.history} />;
}

SurveyViewContainer.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            surveyId: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
    history: PropTypes.object.isRequired,
};
